import React, {

  useCallback,

  useEffect,

  useMemo,

  useState,

} from "react";



import {

  Alert,

  Button,

  Empty,

  Input,

  Modal,

  Select,

  Spin,

  Tooltip,

  Upload,

  Typography,

  message,

} from "antd";



import {

  CheckOutlined,

  DeleteOutlined,

  DownloadOutlined,

  EyeOutlined,

  FilePdfOutlined,

  InboxOutlined,

  ReloadOutlined,

  SearchOutlined,

  UploadOutlined,

  HomeOutlined,

  RightOutlined,

} from "@ant-design/icons";



import "./exam.css";



const { Dragger } = Upload;

const { Title, Text } = Typography;



const API_ROOT =

  process.env.REACT_APP_EXAM_API_BASE_URL ||

  "http://localhost:5000/api/exams";



const API_ORIGIN =

  API_ROOT.replace(/\/api\/exams\/?$/, "");



const SOURCE_OPTIONS = {

  SMART: "smart",

  Trakwel: "Trakwel",

};



const MAX_FILE_SIZE =

  20 * 1024 * 1024;



const MAX_FILES =

  20;



const parseJsonSafely =

  async (response) => {

    const raw =

      await response.text();



    if (!raw) {

      return {

        status:

          response.ok,

        message:

          response.ok

            ? "Request completed"

            : "Request failed",

      };

    }



    try {

      return JSON.parse(

        raw

      );

    } catch {

      console.error(

        "Training material API returned non-JSON response:",

        raw

      );



      return {

        status:

          false,

        message:

          `Server returned an invalid response (${response.status})`,

      };

    }

  };



const getAbsoluteUrl =

  (url) => {

    if (!url) {

      return "";

    }



    if (

      /^https?:\/\//i.test(

        url

      )

    ) {

      return url;

    }



    const normalized =

      url.startsWith("/")

        ? url

        : `/${url}`;



    return `${API_ORIGIN}${normalized}`;

  };



const formatFileSize =

  (bytes) => {

    const value =

      Number(

        bytes || 0

      );



    if (!value) {

      return "-";

    }



    if (

      value < 1024

    ) {

      return `${value} B`;

    }



    if (

      value <

      1024 * 1024

    ) {

      return `${(

        value / 1024

      ).toFixed(1)} KB`;

    }



    return `${(

      value /

      (1024 * 1024)

    ).toFixed(1)} MB`;

  };



const formatDate =

  (value) => {

    if (!value) {

      return "-";

    }



    const date =

      new Date(value);



    if (

      Number.isNaN(

        date.getTime()

      )

    ) {

      return String(

        value

      );

    }



    return date.toLocaleDateString(

      "en-IN",

      {

        day:

          "2-digit",

        month:

          "short",

        year:

          "numeric",

      }

    );

  };



const getUploadUserId =

  (userData) => {

    const id =

      userData?.su_id ||

      userData?.user_id ||

      userData?.id ||

      null;



    const number =

      Number(id);



    return Number.isFinite(

      number

    )

      ? number

      : null;

  };



const ManageTrainingMaterialPage =

  ({

    userData,

  }) => {

    const [

      source,

      setSource,

    ] =

      useState(

        SOURCE_OPTIONS.SMART

      );



    const [

      departments,

      setDepartments,

    ] =

      useState([]);



    const [

      departmentId,

      setDepartmentId,

    ] =

      useState(null);



    const [

      materials,

      setMaterials,

    ] =

      useState([]);



    const [

      selectedFiles,

      setSelectedFiles,

    ] =

      useState([]);



    const [

      search,

      setSearch,

    ] =

      useState("");



    const [

      loadingDepartments,

      setLoadingDepartments,

    ] =

      useState(false);



    const [

      loadingMaterials,

      setLoadingMaterials,

    ] =

      useState(false);



    const [

      uploading,

      setUploading,

    ] =

      useState(false);



    const [

      deletingId,

      setDeletingId,

    ] =

      useState(null);



    const [

      error,

      setError,

    ] =

      useState("");



    const [

      previewOpen,

      setPreviewOpen,

    ] =

      useState(false);



    const [

      previewMaterial,

      setPreviewMaterial,

    ] =

      useState(null);



    const [

      localPreviewUrl,

      setLocalPreviewUrl,

    ] =

      useState("");



    const [

      localPreviewName,

      setLocalPreviewName,

    ] =

      useState("");



    const [

      previewLoading,

      setPreviewLoading,

    ] =

      useState(false);



    const [

      previewError,

      setPreviewError,

    ] =

      useState("");



    const [

      previewMode,

      setPreviewMode,

    ] =

      useState("");



    const uploadUserId =

      useMemo(

        () =>

          getUploadUserId(

            userData

          ),

        [userData]

      );



    const sourceTitle =

      source ===

      SOURCE_OPTIONS.SMART

        ? "SM-ART"

        : "Trakwel";



    const selectedDepartment =

      useMemo(

        () =>

          departments.find(

            (item) =>

              Number(

                item.department_id

              ) ===

              Number(

                departmentId

              )

          ) ||

          null,

        [

          departments,

          departmentId,

        ]

      );



    const filteredMaterials =

      useMemo(

        () => {

          const keyword =

            String(

              search || ""

            )

              .trim()

              .toLowerCase();



          if (!keyword) {

            return materials;

          }



          return materials.filter(

            (item) => {

              const haystack =

                [

                  item.material_title,

                  item.file_name,

                  item.department_name,

                ]

                  .filter(

                    Boolean

                  )

                  .join(

                    " "

                  )

                  .toLowerCase();



              return haystack.includes(

                keyword

              );

            }

          );

        },

        [

          materials,

          search,

        ]

      );



    const fetchDepartments =

      useCallback(

        async (

          selectedSource

        ) => {

          setLoadingDepartments(

            true

          );



          setError("");



          try {

            const response =

              await fetch(

                `${API_ROOT}/training-materials/departments?source=${encodeURIComponent(

                  selectedSource

                )}`

              );



            const body =

              await parseJsonSafely(

                response

              );



            if (

              !response.ok ||

              !body?.status

            ) {

              throw new Error(

                body?.message ||

                "Unable to load departments"

              );

            }



            setDepartments(

              Array.isArray(

                body?.data

              )

                ? body.data

                : []

            );

          } catch (

            err

          ) {

            console.error(

              "Training departments:",

              err

            );



            setDepartments(

              []

            );



            setError(

              err?.message ||

              "Unable to load departments"

            );

          } finally {

            setLoadingDepartments(

              false

            );

          }

        },

        []

      );



    const fetchMaterials =

      useCallback(

        async (

          selectedSource,

          selectedDepartmentId

        ) => {

          if (

            !selectedDepartmentId

          ) {

            setMaterials(

              []

            );



            return;

          }



          setLoadingMaterials(

            true

          );



          setError("");



          try {

            const params =

              new URLSearchParams({

                source:

                  selectedSource,

                department_id:

                  String(

                    selectedDepartmentId

                  ),

                status:

                  "active",

                page:

                  "1",

                limit:

                  "200",

              });



            const response =

              await fetch(

                `${API_ROOT}/training-materials?${params.toString()}`

              );



            const body =

              await parseJsonSafely(

                response

              );



            if (

              !response.ok ||

              !body?.status

            ) {

              throw new Error(

                body?.message ||

                "Unable to load training materials"

              );

            }



            setMaterials(

              Array.isArray(

                body?.data

              )

                ? body.data

                : []

            );

          } catch (

            err

          ) {

            console.error(

              "Training materials:",

              err

            );



            setMaterials(

              []

            );



            setError(

              err?.message ||

              "Unable to load training materials"

            );

          } finally {

            setLoadingMaterials(

              false

            );

          }

        },

        []

      );



    useEffect(

      () => {

        setDepartmentId(

          null

        );



        setSelectedFiles(

          []

        );



        setMaterials(

          []

        );



        setSearch(

          ""

        );



        fetchDepartments(

          source

        );

      },

      [

        source,

        fetchDepartments,

      ]

    );



    useEffect(

      () => {

        if (

          departmentId

        ) {

          fetchMaterials(

            source,

            departmentId

          );

        }

      },

      [

        source,

        departmentId,

        fetchMaterials,

      ]

    );



    const handleSourceChange =

      (

        nextSource

      ) => {

        if (

          nextSource ===

          source

        ) {

          return;

        }



        setPreviewOpen(

          false

        );



        setPreviewMaterial(

          null

        );



        setSource(

          nextSource

        );

      };



    const validatePdf =

      (

        file

      ) => {

        const name =

          String(

            file?.name ||

            ""

          )

            .toLowerCase();



        const type =

          String(

            file?.type ||

            ""

          )

            .toLowerCase();



        if (

          !name.endsWith(

            ".pdf"

          ) ||

          (

            type &&

            type !==

              "application/pdf"

          )

        ) {

          message.error(

            `${file.name}: only PDF files are allowed`

          );



          return false;

        }



        if (

          Number(

            file.size || 0

          ) >

          MAX_FILE_SIZE

        ) {

          message.error(

            `${file.name}: file must be 20 MB or smaller`

          );



          return false;

        }



        return true;

      };



    const beforeUpload =

      (

        file,

        incomingFiles

      ) => {

        if (

          !validatePdf(

            file

          )

        ) {

          return Upload.LIST_IGNORE;

        }



        const validIncoming =

          incomingFiles.filter(

            validatePdf

          );



        setSelectedFiles(

          (current) => {

            const map =

              new Map();



            [

              ...current,

              ...validIncoming,

            ].forEach(

              (item) => {

                const key =

                  `${item.name}-${item.size}-${item.lastModified}`;



                map.set(

                  key,

                  item

                );

              }

            );



            return Array.from(

              map.values()

            ).slice(

              0,

              MAX_FILES

            );

          }

        );



        return false;

      };



    const removeSelectedFile =

      (

        file

      ) => {

        setSelectedFiles(

          (current) =>

            current.filter(

              (item) =>

                !(

                  item.name ===

                    file.name &&

                  item.size ===

                    file.size &&

                  item.lastModified ===

                    file.lastModified

                )

            )

        );

      };



    const uploadSingleFile =

      async (

        file

      ) => {

        const formData =

          new FormData();



        formData.append(

          "source_type",

          source

        );



        formData.append(

          "department_id",

          String(

            departmentId

          )

        );



        formData.append(

          "material_title",

          String(

            file.name || ""

          ).replace(

            /\.pdf$/i,

            ""

          )

        );



        if (

          uploadUserId

        ) {

          formData.append(

            "uploaded_by",

            String(

              uploadUserId

            )

          );

        }



        formData.append(

          "file",

          file

        );



        const response =

          await fetch(

            `${API_ROOT}/training-materials`,

            {

              method:

                "POST",

              body:

                formData,

            }

          );



        const body =

          await parseJsonSafely(

            response

          );



        if (

          !response.ok ||

          !body?.status

        ) {

          throw new Error(

            body?.message ||

            `Failed to upload ${file.name}`

          );

        }



        return body;

      };



    const handleUploadAll =

      async () => {

        if (

          !departmentId

        ) {

          message.warning(

            "Please select a department"

          );



          return;

        }



        if (

          selectedFiles.length ===

          0

        ) {

          message.warning(

            "Please select at least one PDF"

          );



          return;

        }



        setUploading(

          true

        );



        setError(

          ""

        );



        let successCount =

          0;



        const failed =

          [];



        try {

          for (

            const file of

            selectedFiles

          ) {

            try {

              await uploadSingleFile(

                file

              );



              successCount +=

                1;

            } catch (

              err

            ) {

              failed.push(

                {

                  file:

                    file.name,

                  message:

                    err?.message ||

                    "Upload failed",

                }

              );

            }

          }



          if (

            successCount

          ) {

            message.success(

              `${successCount} PDF${

                successCount ===

                1

                  ? ""

                  : "s"

              } uploaded successfully`

            );

          }



          if (

            failed.length

          ) {

            const failedNames =

              failed

                .map(

                  (item) =>

                    item.file

                )

                .join(

                  ", "

                );



            setError(

              `Some files could not be uploaded: ${failedNames}`

            );

          }



          setSelectedFiles(

            []

          );



          await fetchMaterials(

            source,

            departmentId

          );

        } finally {

          setUploading(

            false

          );

        }

      };



    const handleDelete =

      (

        material

      ) => {

        Modal.confirm({

          title:

            "Delete training material?",

          content:

            `This will remove "${material.material_title || material.file_name}" from the training portal.`,

          okText:

            "Delete",

          cancelText:

            "Cancel",

          okButtonProps:

            {

              danger:

                true,

            },



          async onOk() {

            try {

              setDeletingId(

                material.material_id

              );



              const response =

                await fetch(

                  `${API_ROOT}/training-materials/${material.material_id}`,

                  {

                    method:

                      "DELETE",

                  }

                );



              const body =

                await parseJsonSafely(

                  response

                );



              if (

                !response.ok ||

                !body?.status

              ) {

                throw new Error(

                  body?.message ||

                  "Unable to delete training material"

                );

              }



              message.success(

                "Training material deleted"

              );



              await fetchMaterials(

                source,

                departmentId

              );

            } catch (

              err

            ) {

              message.error(

                err?.message ||

                "Unable to delete training material"

              );



              throw err;

            } finally {

              setDeletingId(

                null

              );

            }

          },

        });

      };



    const closePreview =

      () => {

        setPreviewOpen(

          false

        );



        setPreviewMaterial(

          null

        );



        setLocalPreviewName(

          ""

        );



        setPreviewLoading(

          false

        );



        setPreviewError(

          ""

        );



        setPreviewMode(

          ""

        );



        setLocalPreviewUrl(

          (current) => {

            if (

              current &&

              current.startsWith(

                "blob:"

              )

            ) {

              URL.revokeObjectURL(

                current

              );

            }



            return "";

          }

        );

      };



    const handlePreviewSelectedFile =

      (

        file

      ) => {

        if (!file) {

          return;

        }



        setPreviewMaterial(

          null

        );



        setPreviewLoading(

          false

        );



        setPreviewError(

          ""

        );



        setPreviewMode(

          "local"

        );



        setLocalPreviewUrl(

          (current) => {

            if (

              current &&

              current.startsWith(

                "blob:"

              )

            ) {

              URL.revokeObjectURL(

                current

              );

            }



            return URL.createObjectURL(

              file

            );

          }

        );



        setLocalPreviewName(

          file.name ||

          "Selected PDF"

        );



        setPreviewOpen(

          true

        );

      };



    const handlePreviewUploadedMaterial =

      async (

        material

      ) => {

        if (

          !material

        ) {

          return;

        }



        setPreviewMaterial(

          material

        );



        setLocalPreviewName(

          ""

        );



        setPreviewMode(

          "uploaded"

        );



        setPreviewError(

          ""

        );



        setPreviewLoading(

          true

        );



        setLocalPreviewUrl(

          (current) => {

            if (

              current &&

              current.startsWith(

                "blob:"

              )

            ) {

              URL.revokeObjectURL(

                current

              );

            }



            return "";

          }

        );



        setPreviewOpen(

          true

        );



        try {

          const viewUrl =

            getAbsoluteUrl(

              material.view_url

            );



          if (

            !viewUrl

          ) {

            throw new Error(

              "PDF preview URL is unavailable"

            );

          }



          const response =

            await fetch(

              viewUrl,

              {

                method:

                  "GET",

                headers: {

                  Accept:

                    "application/pdf",

                },

              }

            );



          if (

            !response.ok

          ) {

            throw new Error(

              `Unable to load PDF (${response.status})`

            );

          }



          const blob =

            await response.blob();



          if (

            !blob ||

            blob.size === 0

          ) {

            throw new Error(

              "The PDF file is empty"

            );

          }



          const pdfBlob =

            blob.type ===

              "application/pdf"

              ? blob

              : new Blob(

                  [blob],

                  {

                    type:

                      "application/pdf",

                  }

                );



          const objectUrl =

            URL.createObjectURL(

              pdfBlob

            );



          setLocalPreviewUrl(

            objectUrl

          );

        } catch (

          err

        ) {

          console.error(

            "PDF preview:",

            err

          );



          setPreviewError(

            err?.message ||

            "Unable to preview this PDF"

          );

        } finally {

          setPreviewLoading(

            false

          );

        }

      };



    const handleDownload =

      (

        material

      ) => {

        const url =

          getAbsoluteUrl(

            material?.download_url

          );



        if (!url) {

          return;

        }



        const anchor =

          document.createElement(

            "a"

          );



        anchor.href =

          url;



        anchor.target =

          "_blank";



        anchor.rel =

          "noopener noreferrer";



        document.body.appendChild(

          anchor

        );



        anchor.click();



        anchor.remove();

      };



    useEffect(

      () => {

        return () => {

          if (

            localPreviewUrl &&

            localPreviewUrl.startsWith(

              "blob:"

            )

          ) {

            URL.revokeObjectURL(

              localPreviewUrl

            );

          }

        };

      },

      [

        localPreviewUrl,

      ]

    );



    const previewDepartmentName =

      selectedDepartment?.department_name ||

      (

        selectedDepartment?.department_id

          ? `Department ${selectedDepartment.department_id}`

          : "Department"

      );



    const previewDepartmentId =

      selectedDepartment?.department_id ||

      departmentId ||

      "-";



    const previewFileName =

      localPreviewName ||

      previewMaterial?.file_name ||

      previewMaterial?.material_title ||

      "PDF Document";



    const previewPdfUrl =

      localPreviewUrl;



    const refresh =

      () => {

        if (

          departmentId

        ) {

          fetchMaterials(

            source,

            departmentId

          );

        } else {

          fetchDepartments(

            source

          );

        }

      };



    return (

      <div className="exam-management-page exam-management-manage-page manage-training-material-page">

        <section className="exam-management-hero">

          <div className="exam-management-hero-pattern" />



          <div className="exam-management-hero-content">

            <div className="exam-management-hero-copy">

              <div className="exam-management-breadcrumb">

                <span className="exam-management-breadcrumb-home">

                  <HomeOutlined />

                  <span>SM-ART</span>

                </span>



                <RightOutlined />



                <span>

                  Training Materials

                </span>



                <RightOutlined />



                <strong>

                  Manage Training Material

                </strong>

              </div>



              <Title level={3}>

                Manage Training Material

              </Title>



              <Text>

                Upload and manage department-wise PDF training resources.

              </Text>

            </div>

          </div>

        </section>



        <div className="exam-management-content-panel manage-training-content-panel">

          <div className="manage-training-topbar">

            <div>

              <strong>

                Training Material Setup

              </strong>



              <span>

                Select a training source and department, then upload PDF materials.

              </span>

            </div>



            <Button

              icon={

                <ReloadOutlined />

              }

              onClick={

                refresh

              }

              loading={

                loadingDepartments ||

                loadingMaterials

              }

              className="manage-training-refresh"

            >

              Refresh

            </Button>

          </div>



          <section className="manage-training-setup-card">

          <div className="manage-training-section-title">

            <div>

              <strong>

                Training Source

              </strong>



              <span>

                Choose the portal and department before uploading PDFs.

              </span>

            </div>

          </div>



          <div className="manage-training-source-tabs">

            <button

              type="button"

              className={

                source ===

                SOURCE_OPTIONS.SMART

                  ? "manage-training-source-tab is-active"

                  : "manage-training-source-tab"

              }

              onClick={() =>

                handleSourceChange(

                  SOURCE_OPTIONS.SMART

                )

              }

            >

              <span className="manage-training-source-icon">

                S

              </span>



              <span className="manage-training-source-copy">

                <strong>

                  SM-ART

                </strong>



                <small>

                  Smart Manufacturing

                </small>

              </span>



              {source ===

                SOURCE_OPTIONS.SMART && (

                <span className="manage-training-source-check">

                  <CheckOutlined />

                </span>

              )}

            </button>



            <button

              type="button"

              className={

                source ===

                SOURCE_OPTIONS.Trakwel

                  ? "manage-training-source-tab is-active"

                  : "manage-training-source-tab"

              }

              onClick={() =>

                handleSourceChange(

                  SOURCE_OPTIONS.Trakwel

                )

              }

            >

              <span className="manage-training-source-icon">

                T

              </span>



              <span className="manage-training-source-copy">

                <strong>

                  Trakwel

                </strong>



                <small>

                  Training Resources

                </small>

              </span>



              {source ===

                SOURCE_OPTIONS.Trakwel && (

                <span className="manage-training-source-check">

                  <CheckOutlined />

                </span>

              )}

            </button>

          </div>



          <div className="manage-training-department-row">

            <div className="manage-training-field">

              <label>

                Department

              </label>



              <Select

                value={

                  departmentId

                }

                onChange={(

                  value

                ) => {

                  setDepartmentId(

                    value ||

                    null

                  );



                  setSelectedFiles(

                    []

                  );

                }}

                loading={

                  loadingDepartments

                }

                disabled={

                  loadingDepartments

                }

                showSearch

                allowClear

                optionFilterProp="searchText"

                filterOption={(

                  input,

                  option

                ) =>

                  String(

                    option?.searchText ||

                    ""

                  )

                    .toLowerCase()

                    .includes(

                      String(

                        input ||

                        ""

                      ).toLowerCase()

                    )

                }

                placeholder={

                  `Select ${sourceTitle} department`

                }

                popupClassName="manage-training-department-dropdown"

                optionLabelProp="selectedLabel"

                options={

                  departments.map(

                    (

                      department

                    ) => {

                      const deptId =

                        department.department_id;



                      const deptName =

                        department.department_name ||

                        "Department";



                      return {

                        value:

                          Number(

                            deptId

                          ),



                        selectedLabel:

                          deptName,



                        searchText:

                          deptName,



                        label: (

                          <div className="manage-training-dept-option">

                            <div className="manage-training-dept-option-copy">

                              <strong>

                                {deptName}

                              </strong>

                            </div>

                          </div>

                        ),

                      };

                    }

                  )

                }

              />

            </div>



            <div className="manage-training-selected-dept">

              <span>

                Selected

              </span>



              <strong>

                {selectedDepartment
                  ? selectedDepartment.department_name || "Department"
                  : "No department selected"}

              </strong>

            </div>

          </div>

        </section>



        {error && (

          <Alert

            type="error"

            showIcon

            message={

              error

            }

            closable

            onClose={() =>

              setError(

                ""

              )

            }

            className="manage-training-alert"

          />

        )}



        <section className="manage-training-upload-card">

          <div className="manage-training-section-title manage-training-upload-head">

            <div>

              <strong>

                Upload PDF Materials

              </strong>



              <span>

                Select multiple PDF files. Maximum 20 MB per file.

              </span>

            </div>



            <span className="manage-training-file-count">

              {selectedFiles.length} selected

            </span>

          </div>



          <Dragger

            multiple

            accept=".pdf,application/pdf"

            fileList={

              selectedFiles

            }

            beforeUpload={

              beforeUpload

            }

            showUploadList={

              false

            }

            disabled={

              !departmentId ||

              uploading

            }

            className="manage-training-uploader"

          >

            <p className="ant-upload-drag-icon">

              <InboxOutlined />

            </p>



            <p className="manage-training-upload-title">

              Drop PDF files here or click to browse

            </p>



            <p className="manage-training-upload-hint">

              Upload multiple training PDFs to the selected department.

            </p>

          </Dragger>



          {selectedFiles.length > 0 && (

            <div className="manage-training-selected-files">

              <div className="manage-training-selected-files-head">

                <strong>

                  Selected PDFs

                </strong>



                <span>

                  Preview files before uploading

                </span>

              </div>



              <div className="manage-training-selected-files-list">

                {selectedFiles.map(

                  (

                    file,

                    index

                  ) => {

                    const fileKey =

                      `${file.name}-${file.size}-${file.lastModified}-${index}`;



                    return (

                      <div

                        key={

                          fileKey

                        }

                        className="manage-training-selected-file-row"

                      >

                        <div className="manage-training-selected-file-main">

                          <span className="manage-training-selected-file-icon">

                            <FilePdfOutlined />

                          </span>



                          <div className="manage-training-selected-file-copy">

                            <strong

                              title={

                                file.name

                              }

                            >

                              {file.name}

                            </strong>



                            <span>

                              {formatFileSize(

                                file.size

                              )}

                            </span>

                          </div>

                        </div>



                        <div className="manage-training-selected-file-actions">

                          <Tooltip title="Preview PDF">

                            <Button

                              type="text"

                              icon={

                                <EyeOutlined />

                              }

                              onClick={() =>

                                handlePreviewSelectedFile(

                                  file

                                )

                              }

                              className="manage-training-selected-file-button is-preview"

                              aria-label={`Preview ${file.name}`}

                            >

                              <span className="manage-training-selected-file-button-text">

                                Preview

                              </span>

                            </Button>

                          </Tooltip>



                          <Tooltip title="Remove PDF">

                            <Button

                              type="text"

                              danger

                              icon={

                                <DeleteOutlined />

                              }

                              onClick={() =>

                                removeSelectedFile(

                                  file

                                )

                              }

                              disabled={

                                uploading

                              }

                              className="manage-training-selected-file-button is-remove"

                              aria-label={`Remove ${file.name}`}

                            >

                              <span className="manage-training-selected-file-button-text">

                                Remove

                              </span>

                            </Button>

                          </Tooltip>

                        </div>

                      </div>

                    );

                  }

                )}

              </div>

            </div>

          )}



          <div className="manage-training-upload-actions">

            <Button

              onClick={() =>

                setSelectedFiles(

                  []

                )

              }

              disabled={

                selectedFiles.length ===

                  0 ||

                uploading

              }

            >

              Clear

            </Button>



            <Button

              type="primary"

              icon={

                <UploadOutlined />

              }

              loading={

                uploading

              }

              disabled={

                !departmentId ||

                selectedFiles.length ===

                  0

              }

              onClick={

                handleUploadAll

              }

              className="manage-training-upload-button"

            >

              {uploading

                ? "Uploading..."

                : `Upload ${

                    selectedFiles.length ||

                    ""

                  } PDF${

                    selectedFiles.length ===

                    1

                      ? ""

                      : "s"

                  }`}

            </Button>

          </div>

        </section>



        <section className="manage-training-list-card">

          <div className="manage-training-list-toolbar">

            <div className="manage-training-section-title">

              <div>

                <strong>

                  Uploaded Materials

                </strong>



                <span>

                  {selectedDepartment

                    ? `${

                        selectedDepartment.department_name ||

                        `Department ${selectedDepartment.department_id}`

                      } • Dept ID: ${

                        selectedDepartment.department_id

                      } • ${sourceTitle}`

                    : "Select a department to view uploaded materials"}

                </span>

              </div>

            </div>



            <div className="manage-training-list-tools">

              <Input

                value={

                  search

                }

                onChange={(

                  event

                ) =>

                  setSearch(

                    event.target.value

                  )

                }

                prefix={

                  <SearchOutlined />

                }

                placeholder="Search title or file"

                allowClear

                disabled={

                  !departmentId

                }

              />



              {departmentId && (

                <span className="manage-training-total-pill">

                  {filteredMaterials.length} PDF

                  {filteredMaterials.length ===

                  1

                    ? ""

                    : "s"}

                </span>

              )}

            </div>

          </div>



          {loadingMaterials ? (

            <div className="manage-training-loading">

              <Spin />



              <span>

                Loading training materials...

              </span>

            </div>

          ) : !departmentId ? (

            <Empty

              image={

                Empty.PRESENTED_IMAGE_SIMPLE

              }

              description="Select a department to continue"

              className="manage-training-empty"

            />

          ) : filteredMaterials.length ===

            0 ? (

            <Empty

              image={

                Empty.PRESENTED_IMAGE_SIMPLE

              }

              description={

                search

                  ? "No training material matches your search"

                  : "No training material uploaded for this department"

              }

              className="manage-training-empty"

            />

          ) : (

            <div className="manage-training-table-wrap">

              <div className="manage-training-table-head">

                <span>

                  Material

                </span>



                <span>

                  Department

                </span>



                <span>

                  File Size

                </span>



                <span>

                  Uploaded

                </span>



                <span>

                  Actions

                </span>

              </div>



              {filteredMaterials.map(

                (

                  material

                ) => (

                  <div

                    key={

                      material.material_id

                    }

                    className="manage-training-row"

                  >

                    <div className="manage-training-material-name">

                      <span className="manage-training-pdf-icon">

                        <FilePdfOutlined />

                      </span>



                      <div>

                        <strong>

                          {material.material_title ||

                            "Training Material"}

                        </strong>



                        <span>

                          {material.file_name ||

                            "PDF Document"}

                        </span>

                      </div>

                    </div>



                    <div className="manage-training-cell">

                      <span className="manage-training-mobile-label">

                        Department

                      </span>



                      <strong>

                        {material.department_name ||

                          selectedDepartment?.department_name ||

                          "-"}

                        {(

                          material.department_id ||

                          selectedDepartment?.department_id

                        )

                          ? ` • ID: ${

                              material.department_id ||

                              selectedDepartment?.department_id

                            }`

                          : ""}

                      </strong>

                    </div>



                    <div className="manage-training-cell">

                      <span className="manage-training-mobile-label">

                        File Size

                      </span>



                      <strong>

                        {formatFileSize(

                          material.file_size

                        )}

                      </strong>

                    </div>



                    <div className="manage-training-cell">

                      <span className="manage-training-mobile-label">

                        Uploaded

                      </span>



                      <strong>

                        {formatDate(

                          material.created_at

                        )}

                      </strong>

                    </div>



                    <div className="manage-training-actions">

                      <Tooltip title="Preview PDF">

                        <Button

                          icon={

                            <EyeOutlined />

                          }

                          onClick={() =>

                            handlePreviewUploadedMaterial(

                              material

                            )

                          }

                          className="manage-training-action-button is-view"

                          aria-label={`Preview ${material.material_title || material.file_name || "PDF"}`}

                        />

                      </Tooltip>



                      <Tooltip title="Download PDF">

                        <Button

                          icon={

                            <DownloadOutlined />

                          }

                          onClick={() =>

                            handleDownload(

                              material

                            )

                          }

                          className="manage-training-action-button is-download"

                          aria-label={`Download ${material.material_title || material.file_name || "PDF"}`}

                        />

                      </Tooltip>



                      <Tooltip title="Delete PDF">

                        <Button

                          danger

                          icon={

                            <DeleteOutlined />

                          }

                          loading={

                            deletingId ===

                            material.material_id

                          }

                          onClick={() =>

                            handleDelete(

                              material

                            )

                          }

                          className="manage-training-action-button is-delete"

                          aria-label={`Delete ${material.material_title || material.file_name || "PDF"}`}

                        />

                      </Tooltip>

                    </div>

                  </div>

                )

              )}

            </div>

          )}

        </section>



        </div>



        <Modal

          open={

            previewOpen

          }

          title={

            null

          }

          onCancel={

            closePreview

          }

          footer={

            null

          }

          width="100vw"

          style={{

            top: 0,

            paddingBottom: 0,

            margin: 0,

            maxWidth: "100vw",

          }}

          destroyOnClose

          className="manage-training-preview-modal"

          rootClassName="manage-training-modal-root"

        >

          <div className="manage-training-preview-shell">

            <div className="manage-training-preview-header">

              <div className="manage-training-preview-title-wrap">

                <span className="manage-training-preview-pdf-icon">

                  <FilePdfOutlined />

                </span>



                <div className="manage-training-preview-title-copy">

                  <strong

                    title={

                      previewFileName

                    }

                  >

                    {previewFileName}

                  </strong>



                  <span>

                    {previewMode ===

                    "local"

                      ? "Preview before upload"

                      : "Uploaded training material"}

                  </span>

                </div>



                <div className="manage-training-preview-header-meta">

                  <div>

                    <span>Source</span>

                    <strong>{sourceTitle}</strong>

                  </div>



                  <div>

                    <span>Department</span>

                    <strong>{previewDepartmentName}</strong>

                  </div>



                  <div>

                    <span>Dept ID</span>

                    <strong>{previewDepartmentId}</strong>

                  </div>



                  <div>

                    <span>Status</span>

                    <strong>

                      {previewMode ===

                      "local"

                        ? "Ready to Upload"

                        : "Uploaded"}

                    </strong>

                  </div>

                </div>

              </div>



              <Button

                type="text"

                onClick={

                  closePreview

                }

                className="manage-training-preview-close"

              >

                Close

              </Button>

            </div>



            <div className="manage-training-preview-viewer">

              {previewLoading ? (

                <div className="manage-training-preview-state">

                  <Spin

                    size="large"

                  />



                  <strong>

                    Loading PDF...

                  </strong>



                  <span>

                    Preparing the document preview.

                  </span>

                </div>

              ) : previewError ? (

                <div className="manage-training-preview-state is-error">

                  <FilePdfOutlined />



                  <strong>

                    Preview unavailable

                  </strong>



                  <span>

                    {previewError}

                  </span>



                  {previewMaterial && (

                    <Button

                      icon={

                        <DownloadOutlined />

                      }

                      onClick={() =>

                        handleDownload(

                          previewMaterial

                        )

                      }

                    >

                      Download PDF

                    </Button>

                  )}

                </div>

              ) : previewPdfUrl ? (

                <iframe

                  src={

                    `${previewPdfUrl}#view=FitH&navpanes=0`

                  }

                  title={

                    previewFileName

                  }

                  className="manage-training-preview-frame"

                />

              ) : (

                <div className="manage-training-preview-state is-error">

                  <FilePdfOutlined />



                  <strong>

                    Preview unavailable

                  </strong>



                  <span>

                    PDF content could not be loaded.

                  </span>

                </div>

              )}

            </div>



            <div className="manage-training-preview-footer">

              <span>

                {previewMode ===

                "local"

                  ? "Review this PDF before uploading it to the selected department."

                  : "Previewing the uploaded training material."}

              </span>



              <div>

                {previewMaterial && (

                  <Button

                    icon={

                      <DownloadOutlined />

                    }

                    onClick={() =>

                      handleDownload(

                        previewMaterial

                      )

                    }

                  >

                    Download

                  </Button>

                )}



                <Button

                  type="primary"

                  onClick={

                    closePreview

                  }

                >

                  Done

                </Button>

              </div>

            </div>

          </div>

        </Modal>

      </div>

    );

  };



export default ManageTrainingMaterialPage;
